import { render, staticRenderFns } from "./UserCategoriesList.vue?vue&type=template&id=01aca46c&"
import script from "./UserCategoriesList.vue?vue&type=script&lang=js&"
export * from "./UserCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports